module.exports = __webpack_public_path__ + "img/SYR.c99e8ff3.svg";